import React from 'react';

import { Icon } from '../icons';

export const PlusLightIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M31.3333333,14 L18,14 L18,0.666666667 C18,0.298333333 17.7016667,0 17.3333333,0 L14.6666667,0 C14.2983333,0 14,0.298333333 14,0.666666667 L14,14 L0.666666667,14 C0.298333333,14 0,14.2983333 0,14.6666667 L0,17.3333333 C0,17.7016667 0.298333333,18 0.666666667,18 L14,18 L14,31.3333333 C14,31.7016667 14.2983333,32 14.6666667,32 L17.3333333,32 C17.7016667,32 18,31.7016667 18,31.3333333 L18,18 L31.3333333,18 C31.7016667,18 32,17.7016667 32,17.3333333 L32,14.6666667 C32,14.2983333 31.7016667,14 31.3333333,14 Z" />
    </svg>
  );
};
